<template>
  <CalendarList v-if="mobile" />
  <CalendarTuiWrapper v-else />
</template>

<script>
import { mapGetters } from 'vuex'
import CalendarList from '@/components/Calendar/CalendarList'
import CalendarTuiWrapper from '@/components/Calendar/CalendarTuiWrapper'

export default {
  name: 'CalendarDisplay',
  components: {
    CalendarList,
    CalendarTuiWrapper
  },
  computed: {
    ...mapGetters('calendar', [
      'getView'
    ]),
    mobile () {
      return this.getView
    }
  }
}
</script>

<style scoped>

</style>
